import { getDisplayTimezone } from "./format";
import { addDaysInZone, dayStartInZone } from "./timezone";

export function dayStartMs(ts: number): number {
  return localDayStartMs(ts);
}

export function utcDayStartMs(ts: number): number {
  const d = new Date(ts);
  d.setUTCHours(0, 0, 0, 0);
  return d.getTime();
}

export function addDays(ts: number, days: number): number {
  return addDaysInZone(ts, days, getDisplayTimezone());
}

export function formatDay(ts: number): string {
  return new Intl.DateTimeFormat(undefined, {
    timeZone: getDisplayTimezone(),
    weekday: "short",
    month: "short",
    day: "numeric",
  }).format(new Date(ts));
}

export function clientLogTimes(date: number): {
  readonly clientDayStart: number;
  readonly clientLoggedAt: number;
} {
  return {
    clientDayStart: localDayStartMs(date),
    clientLoggedAt: Date.now(),
  };
}

export function localDayStartMs(ts: number): number {
  return dayStartInZone(ts, getDisplayTimezone());
}
